module.exports = __webpack_public_path__ + "img/st-patricks-sharing.941da2ae.png";